import React from "react";
import { clsx } from "clsx";
import Tag from "./Tag";

interface IPostTitleProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

export default function PostTitle(props: IPostTitleProps) {
  const { post } = props;
  const { category, tag: tags, title } = post;

  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "font-light",
        "items-center",
        "lg:max-w-3xl",
        "md:max-w-2xl",
        "px-4",
        "py-2",
        "space-y-2",
      )}
    >
      {category && (
        <p className={clsx("font-bold", "text-primary", "text-sm")}>
          #{category.name}
        </p>
      )}
      <div className={clsx("font-bold", "text-2xl")}>
        <div className={clsx("h-full", "w-2")} />
        <h1>{title}</h1>
      </div>
      <div
        className={clsx("flex", "flex-wrap", "justify-center", "gap-1", "px-3")}
      >
        {tags &&
          (tags as Queries.MicrocmsPostTag[]).map((tag) => {
            return (
              <Tag
                key={tag.id}
                tagId={tag.id ?? ""}
                name={tag.name ?? ""}
                primary
              />
            );
          })}
      </div>
    </div>
  );
}
